import { createNavigation } from 'next-intl/navigation';
import { type ComponentProps } from 'react';

import { isExternalURL } from '@commons/helpers/url';

import { routingConfig } from './routing';

/**
 * Defining `next-intl` wrappers for Next.js.
 *
 * Uses the shared pathnames navigation strategy.
 * This would need to be updated if we change to the localized pathnames strategy.
 *
 * @see https://next-intl-docs.vercel.app/docs/routing/navigation#shared-pathnames
 */

const { Link, redirect, permanentRedirect, usePathname, useRouter, getPathname } =
  createNavigation(routingConfig);

/**
 * Wrapper around `next-intl` Link component to handle external links automatically.
 */

const WrappedLink = (props: ComponentProps<typeof Link>) => {
  const { href, target, children, ref, ...rest } = props;

  const isExternal = isExternalURL(href);

  return (
    <Link
      ref={ref}
      href={href}
      target={target || (isExternal ? '_blank' : undefined)}
      rel={isExternal ? 'noopener noreferrer' : undefined}
      {...rest}
    >
      {children}
    </Link>
  );
};

/**
 * Exporting the `next-intl` wrappers and the custom `Link` component.
 */

export { WrappedLink as Link, redirect, permanentRedirect, usePathname, useRouter, getPathname };
